import * as React from "react";
import { Confirm } from "semantic-ui-react";

interface Props {
    isOpen: boolean;
    employeeFirstName: string;
    employeeLastName: string;
    onConfirm: () => void;
    onClose: () => void;
}

export const CloseMonitoringChangeConfirmModal: React.FunctionComponent<Props> = (props: Props) => {
    const close =  React.useCallback(() => {
        props.onClose();
    }, [props]);

    const confirm = React.useCallback(() => {
        props.onConfirm();
        close();
    }, [close, props]);

    const content = (<>
        <div>You are about to change close monitoring for {props.employeeFirstName} {props.employeeLastName}. Are you sure you wish to continue?</div>
        <br />
    </>);
    return (
        <Confirm
            open={props.isOpen}
            header="Close Monitoring"
            content={{ content }}
            onCancel={close}
            onConfirm={confirm}
            size="large"
            confirmButton={{ children: "Confirm" }}
        />
    );
};
